import { render } from "./ContributionCategory.vue?vue&type=template&id=240db0af&scoped=true"
import script from "./ContributionCategory.vue?vue&type=script&lang=js"
export * from "./ContributionCategory.vue?vue&type=script&lang=js"

import "./ContributionCategory.vue?vue&type=style&index=0&id=240db0af&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-240db0af"]])

export default __exports__